import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  typography: {
    fontFamily: `'Poppins', sans-serif`,
  },
  palette: {
    primary: {
      main: "#bbbbbb12",
      second: "gray",
      background: "#131a25",
      backgroundHeader: "#131a25",
      textColor: "#e6eaeb",
      secondTextColor: "#c9c9c9",
    },
    secondary: {
      main: "#007A33",
      backgroundVis: "#131a25", //"#0080002b",
      itemBackground: "#bbbbbb0a",
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
